(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4593],{

/***/ 4593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RunnerOld": function() { return /* binding */ RunnerOld; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _comps_bubble__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5232);
/* harmony import */ var _comps_floating__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(501);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9612);
/* harmony import */ var _comps_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1156);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(177);
/* harmony import */ var react_styled_flex__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4382);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9521);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6010);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4870);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_10__);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	opacity: 0;\n	transition: opacity 300ms;\n	transition-timing-function: ease-in-out;\n\n	&:hover {\n		opacity: 1;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	0% {\n		transform: translateX(0);\n	}\n	100% {\n		transform: translateX(-1831px);\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		zoom: 1;\n		scale: 0.6;\n	"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: row;\n	align-items: center;\n	gap: 42px;\n\n	width: max-content;\n\n	animation: ",
        " 30s linear -0s infinite normal forwards;\n\n	&:hover {\n		animation-play-state: paused;\n	}\n\n	height: 60px;\n\n	zoom: 0.8;\n	scale: 0.5;\n	margin-bottom: 0px;\n\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		padding-top: unset;\n		gap: 24px;\n	"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	gap: 16px;\n	background: var(--color-cell);\n\n	padding-top: 12px;\n\n	",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}











var logos = [
    {
        images: [
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/pod-ml.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/pod-cl.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/pod-md.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/pod-cd.webp"), 
        ],
        url: "https://podcastle.ai/"
    },
    {
        images: [
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/web-ml.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/web-cl.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/web-md.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/web-cd.webp"), 
        ],
        url: "https://10web.io/"
    },
    {
        images: [
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/code-ml.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/code-cl.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/code-md.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/code-cd.webp"), 
        ],
        url: "https://codesignal.com/"
    },
    {
        images: [
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/coin-ml.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/coin-cl.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/coin-md.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/coin-cd.webp"), 
        ],
        url: "https://coinstats.app/"
    },
    {
        images: [
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/easy-ml.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/easy-cl.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/easy-md.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/easy-cd.webp"), 
        ],
        url: "https://easydmarc.com/"
    },
    {
        images: [
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/krisp-ml.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/krisp-cl.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/krisp-md.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/krisp-cd.webp"), 
        ],
        url: "https://krisp.ai/"
    },
    {
        images: [
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/sc-ml.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/sc-cl.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/sc-md.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/sc-cd.webp"), 
        ],
        url: "https://smartclick.ai/"
    },
    {
        images: [
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/tcff-ml.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/tcff-cl.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/tcff-md.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/tcff-cd.webp"), 
        ],
        url: "https://thecrowdfundingformula.com/"
    },
    {
        images: [
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/zero-ml.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/zero-cl.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/zero-md.webp"),
            (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/runner/zero-cd.webp"), 
        ],
        url: "https://zerosystems.com/"
    }, 
];
var Colorful = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-3d7003c4-0"
})(_templateObject());
var runnerAnim = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .keyframes */ .F4)(_templateObject1());
var RunnerContainer = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3d7003c4-1"
})(_templateObject3(), runnerAnim, (0,_utils_breakpoints__WEBPACK_IMPORTED_MODULE_6__/* .onDesktop */ .X$)((0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject2())));
var PartnersContainer = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3d7003c4-2"
})(_templateObject5(), (0,_utils_breakpoints__WEBPACK_IMPORTED_MODULE_6__/* .onDesktop */ .X$)((0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject4())));
var Anchor = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-3d7003c4-3"
})(_templateObject6());
var RunnerOld = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PartnersContainer, {
        id: "partners",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["partners-title"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_7__/* .FlexItem */ .B5, {
                        box: true,
                        center: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_bubble__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            text: "txt_our_partners",
                            color: "tan"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_breakpoints__WEBPACK_IMPORTED_MODULE_6__/* .Desktop */ .Hi, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_styled_flex__WEBPACK_IMPORTED_MODULE_7__/* .FlexBox */ .hs, {
                            alignItems: "flex-end",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    content: "txt_published_on",
                                    size: "44",
                                    weight: "800"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                    marginBottom: 16,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/trusted-dot.svg"),
                                        alt: "trusted dot icon"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_breakpoints__WEBPACK_IMPORTED_MODULE_6__/* .TabletOrMobile */ .Vi, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_styled_flex__WEBPACK_IMPORTED_MODULE_7__/* .FlexBox */ .hs, {
                            gap: 4,
                            alignItems: "flex-end",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    content: "txt_published_on",
                                    size: "28",
                                    weight: "800"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                    marginBottom: 8,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/icons/home/platforms/trusted-dot.svg"),
                                        alt: "trusted dot icon"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RunnerContainer, {
                children: [
                    logos.map(function(param, i) {
                        var _images = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(param.images, 4), greyLight = _images[0], colorfulLight = _images[1], greyDark = _images[2], colorfulDark = _images[3], url = param.url;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Anchor, {
                            href: url,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_4__/* .CustomThemedResource */ .aK, {
                                    source: "",
                                    format: "webp"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_4__/* .ThemedImage */ .RJ, {
                                    light: greyLight,
                                    dark: greyDark
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_comps_floating__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    position: {
                                        top: 0,
                                        left: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                            "data-hide-on-theme": "dark",
                                            src: colorfulLight,
                                            alt: "runner logo light"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                            "data-hide-on-theme": "light",
                                            src: colorfulDark,
                                            alt: "runner logo light"
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    }),
                    logos.map(function(param, i) {
                        var _images = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(param.images, 4), greyLight = _images[0], colorfulLight = _images[1], greyDark = _images[2], colorfulDark = _images[3], url = param.url;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Anchor, {
                            href: url,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_4__/* .ThemedImage */ .RJ, {
                                    light: greyLight,
                                    dark: greyDark
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_comps_floating__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    position: {
                                        top: 0,
                                        left: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                            "data-hide-on-theme": "dark",
                                            alt: "runner logo light",
                                            src: colorfulLight
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                            "data-hide-on-theme": "light",
                                            src: colorfulDark,
                                            alt: "runner logo dark"
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    }),
                    logos.map(function(param, i) {
                        var _images = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(param.images, 4), greyLight = _images[0], colorfulLight = _images[1], greyDark = _images[2], colorfulDark = _images[3], url = param.url;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Anchor, {
                            href: url,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_4__/* .ThemedImage */ .RJ, {
                                    light: greyLight,
                                    dark: greyDark
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_comps_floating__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    position: {
                                        top: 0,
                                        left: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                            "data-hide-on-theme": "dark",
                                            src: colorfulLight,
                                            alt: "runner logo dark"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                            "data-hide-on-theme": "light",
                                            src: colorfulDark,
                                            alt: "runner logo dark"
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    }),
                    logos.map(function(param, i) {
                        var _images = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(param.images, 4), greyLight = _images[0], colorfulLight = _images[1], greyDark = _images[2], colorfulDark = _images[3], url = param.url;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Anchor, {
                            href: url,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_4__/* .ThemedImage */ .RJ, {
                                    light: greyLight,
                                    dark: greyDark
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_comps_floating__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    position: {
                                        top: 0,
                                        left: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                            "data-hide-on-theme": "dark",
                                            src: colorfulLight,
                                            alt: "runner logo dark"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                            "data-hide-on-theme": "light",
                                            src: colorfulDark,
                                            alt: "runner logo dark"
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                ]
            })
        ]
    });
};
var companyReferences = [
    {
        name: "backstage",
        link: "https://www.backstage.com"
    },
    {
        name: "forbes",
        link: "https://www.forbes.com/sites/cindygordon/2023/06/25/zoomerang-short-form-ai-video-platform-is-a-creative-innovation/amp/"
    },
    {
        name: "google",
        link: "https://developers.googleblog.com/2023/04/weareplay-meet-maria-annmaria-and-dennis-from-the-usa-more-stories-from-around-the-world.html"
    },
    {
        name: "imh",
        link: "https://influencermarketinghub.com"
    },
    {
        name: "meta",
        link: "https://developers.facebook.com/success-stories/zoomerang/"
    },
    {
        name: "msn",
        link: "https://www.msn.com/"
    },
    {
        name: "trend",
        link: "https://www.trendhunter.com"
    },
    {
        name: "yahoo",
        link: "https://finance.yahoo.com/"
    }, 
];
var Runner = function(props) {
    var className = props.className, bgColor = props.bgColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("w-full overflow-hidden ", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PartnersContainer, {
            id: "partners",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(bgColor ? "bg-color-".concat(bgColor) : "bg-color-cell", "absolute left-[calc(50%-50vw)] top-0 z-[1] h-[60px] desktop:w-[calc(50vw-587px)]")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(bgColor ? "bg-color-".concat(bgColor) : "bg-color-cell", "absolute right-[calc(50%-50vw)] top-0 z-[1] h-[60px] desktop:w-[calc(50vw-587px)]")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(bgColor ? "from-color-".concat(bgColor) : "from-color-cell", "pointer-events-none absolute left-[calc(50%-50vw)] top-0 z-[1] h-[60px] w-20 bg-gradient-to-r to-color-white/0 desktop:left-[calc(50%-587px)] desktop:w-40")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(bgColor ? "from-color-".concat(bgColor) : "from-color-cell", "pointer-events-none absolute right-[calc(50%-50vw)] top-0 z-[1] h-[60px] w-20 bg-gradient-to-l to-color-white/0 desktop:right-[calc(50%-587px)] desktop:w-40")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RunnerContainer, {
                        children: [
                            companyReferences.map(function(param, i) {
                                var name = param.name, link = param.link;
                                var greyLight = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-grey-light.webp");
                                var greyDark = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-dark-grey.webp");
                                var colorsLight = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-light-colors.webp");
                                var colorsDark = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-dark-colors.webp");
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Anchor, {
                                    href: link,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            "data-hide-on-theme": "dark",
                                            src: greyLight,
                                            alt: "anchor icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            "data-hide-on-theme": "light",
                                            src: greyDark,
                                            alt: "anchor icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_comps_floating__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            position: {
                                                top: 0,
                                                left: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                                    "data-hide-on-theme": "dark",
                                                    src: colorsLight,
                                                    alt: "runner logo dark"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                                    "data-hide-on-theme": "light",
                                                    src: colorsDark,
                                                    alt: "runner logo dark"
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            }),
                            companyReferences.map(function(param, i) {
                                var name = param.name, link = param.link;
                                var greyLight = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-grey-light.webp");
                                var greyDark = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-dark-grey.webp");
                                var colorsLight = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-light-colors.webp");
                                var colorsDark = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-dark-colors.webp");
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Anchor, {
                                    href: link,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            "data-hide-on-theme": "dark",
                                            src: greyLight,
                                            alt: "anchor icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            "data-hide-on-theme": "light",
                                            src: greyDark,
                                            alt: "anchor icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_comps_floating__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            position: {
                                                top: 0,
                                                left: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                                    "data-hide-on-theme": "dark",
                                                    src: colorsLight,
                                                    alt: "runner logo dark"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                                    "data-hide-on-theme": "light",
                                                    src: colorsDark,
                                                    alt: "runner logo dark"
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            }),
                            companyReferences.map(function(param, i) {
                                var name = param.name, link = param.link;
                                var greyLight = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-grey-light.webp");
                                var greyDark = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-dark-grey.webp");
                                var colorsLight = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-light-colors.webp");
                                var colorsDark = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-dark-colors.webp");
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Anchor, {
                                    href: link,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            "data-hide-on-theme": "dark",
                                            src: greyLight,
                                            alt: "anchor icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            "data-hide-on-theme": "light",
                                            src: greyDark,
                                            alt: "anchor icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_comps_floating__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            position: {
                                                top: 0,
                                                left: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                                    "data-hide-on-theme": "dark",
                                                    src: colorsLight,
                                                    alt: "runner logo dark"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                                    "data-hide-on-theme": "light",
                                                    src: colorsDark,
                                                    alt: "runner logo dark"
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            }),
                            companyReferences.map(function(param, i) {
                                var name = param.name, link = param.link;
                                var greyLight = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-grey-light.webp");
                                var greyDark = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-dark-grey.webp");
                                var colorsLight = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-light-colors.webp");
                                var colorsDark = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/published/" + name + "-dark-colors.webp");
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Anchor, {
                                    href: link,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            "data-hide-on-theme": "dark",
                                            src: greyLight,
                                            alt: "anchor icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            "data-hide-on-theme": "light",
                                            src: greyDark,
                                            alt: "anchor icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_comps_floating__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            position: {
                                                top: 0,
                                                left: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                                    "data-hide-on-theme": "dark",
                                                    src: colorsLight,
                                                    alt: "runner logo dark"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Colorful, {
                                                    "data-hide-on-theme": "light",
                                                    src: colorsDark,
                                                    alt: "runner logo dark"
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Runner);


/***/ }),

/***/ 4870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__P5185","bubble-column-right":"styles_bubble-column-right__nn_8J","star":"styles_star__V9kU7","float-randomly":"styles_float-randomly__apHaF","poping-image-container":"styles_poping-image-container__9HXMs","poping-image":"styles_poping-image__J4iUv","top-icon":"styles_top-icon__OJjH7","image-appear":"styles_image-appear__FJ8Cx","partners-title":"styles_partners-title__etUun","trusted-container":"styles_trusted-container__w0QN_","trusted-dot":"styles_trusted-dot__juIB3"};

/***/ })

}]);